import React from "react";
import MissionCards from "../sections/MissionCards";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";

const Mission = ({missions}) => {
    if (!missions || missions.length === 0) {
        return null;
    }

    return (
        <div className="wow fadeInUp" data-wow-delay="0.1s">
            <MissionCards data={missions} icon={faBullseye} color="purple" />
        </div>
    );
};
  
export default Mission;